const normalizeName = value => (value || '').trim();

const hasUsableName = value => {
  const normalizedValue = normalizeName(value);
  return !!normalizedValue;
};

const hasUsableHandle = value => {
  const normalizedValue = normalizeName(value);
  return normalizedValue.length >= 3 && /^[a-z0-9_]+$/.test(normalizedValue);
};

export const isPlaceholderProfileName = (firstName, lastName) =>
  normalizeName(firstName).toLowerCase() === 'riticket' &&
  normalizeName(lastName).toLowerCase() === 'member';

export const needsProfileSetup = currentUser => {
  const profile = currentUser?.attributes?.profile || {};
  const firstName = normalizeName(profile.firstName);
  const lastName = normalizeName(profile.lastName);
  const handle = normalizeName(profile.publicData?.handle);
  return (
    isPlaceholderProfileName(firstName, lastName) ||
    !hasUsableName(firstName) ||
    !hasUsableName(lastName) ||
    !hasUsableHandle(handle)
  );
};
